import { Box, TextField } from "@mui/material";
import React from "react";
import { Autocomplete } from "@mui/material";
import useStyles from "./style";

export default function CustomSingleSelect({
  label,
  options,
  defaultValue,
  onChange,
  autoCompleteSize = "small",
  popperClassName = "",
  autoCompleteClassName = "",
  ...props
}) {
  const classes = useStyles();

  const selectedOption =
    options?.find((option) => option.value === defaultValue) || null;

  return (
    <Box className={classes.selectField}>
      <Autocomplete
        id="combo-box"
        options={options || []}
        value={selectedOption}
        className={autoCompleteClassName}
        size={autoCompleteSize}
        classes={{
          popper: classes[popperClassName],
          listbox: classes.listbox,
          inputRoot: classes.inputRoot
        }}
        onChange={(event, selectedOption) => onChange(selectedOption || {})}
        getOptionLabel={(option) => option.label || ""}
        filterOptions={(options, state) =>
          options.filter(
            (option) =>
              option.value.toLowerCase().includes(state.inputValue.toLowerCase()) ||
              option.label.toLowerCase().includes(state.inputValue.toLowerCase())
          )
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
          />
        )}
        {...props}
      />
    </Box>
  );
}
